/**
 * Copyright (c) 2021-2024 Kognitos, Inc. All rights reserved.
 */
export enum WorkerState {
  CREATING = 'creating',
  CREATED = 'created',
  PROCESSING = 'processing',
  USER_STOPPED = 'user stopped',
  WAITING_FOR_USER_INPUT = 'waiting_for_user_input',
  DONE = 'done',
  DELETED = 'deleted',
  ERROR = 'error',
  STARTED = 'started',
  PREPARING_KNOWLEDGE = 'preparing_knowledge',
  KNOWLEDGE_READY = 'ready'
}
